import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class VolumeSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    return selectedPoints
      .flatMap((p) => p)
      .map((p, idx) => {
        const hasComparison = p.series.options.custom?.hasOwnProperty('seriesId');

        let translationKey = `widgets.ai-insights.summary.${widget.payload.type}`;
        translationKey = `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`;
        translationKey = `${translationKey}.${hasComparison ? 'has-comparison' : 'no-comparison'}`;

        return {
          translationKey,
          translationParams: {
            fieldValue: p.pointDisplay ?? p.pointId ?? p.category,
            comparison: p.series.name,
            count: Utils.round(p.documentCount ?? p.y),
          },
        };
      });
  }
}
